import APICom from '../../utils/helpers/APICom';
import React, { useEffect, useState, useRef } from 'react';
import ConfirmationModal from '../Controls/ConfirmationModal';

const GlobalSettings = ({ AffID, _algorithms }) => {
  const xCancelSourceForGrid = useRef(null);
    const [confirmationModalObj, setConfirmationModalObj] = useState({
      show: false, title: 'Confirmation',
      body: 'Are you Sure you want to Delete Rule?', btnCanceText: 'No',
      btnOkText: 'Yes', closeOnly: false, isCancel: false
    });
    const [confirmationModalObj1, setConfirmationModalObj1] = useState({
      show: false, title: 'Confirmation',
      body: 'Are you Sure you want to Delete Rule?', btnCanceText: 'No',
      btnOkText: 'Yes',
    });
  const [operationConstraintsData, setoperationConstraintsData] = useState({
    autoRoutingMode: '',
    periodicTimer: '',
    iOtherManualActionsAlgoTypeID:'',
    iPredictiveAlgoTypeID:'',
    iFinalRunAlgoTypeID:'',
    iPeriodicAlgoTypeID:'',
    iManBatchRoutingAlgoTypeID:'',
    iManSingleRoutingAlgoTypeID:''
  });
    const handleConfirmationModalOk = async () => {
          setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
    setConfirmationModalObj1((prevState) => ({ ...prevState, show: false }));
    }
  const handleConfirmationModalClose = () => {
    setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
    setConfirmationModalObj1((prevState) => ({ ...prevState, show: false }));
  }
  const handleConfirmationModalCancel = () => {
    setConfirmationModalObj((prevState) => ({ ...prevState, show: false }));
    setConfirmationModalObj1((prevState) => ({ ...prevState, show: false }));
  }
  const handleConstraintsChange = (e) => {
    const { name, value, type, checked } = e.target;
    setoperationConstraintsData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const algorithms = _algorithms.map(item => ({
    id: item.iValue.toString(),
    name: item.DisplayName
  }));
  const GetAffiliateLevelRouteSettings = async (iAffiliateID) => {
    xCancelSourceForGrid.current = APICom.GenerateSource();


    try {
        let response = await APICom.fetchData("GenericManifestDotNetCoreURL", `api/Routing/GetAffiliateLevelRouteSettings?iAffiliateID=${iAffiliateID}`, "get",
          {}, {}, xCancelSourceForGrid.current
        );
        console.log(response);
        if (response?.data) {
          console.log("Data:", response.data);
          setoperationConstraintsData(prevState => ({
          ...prevState,
          autoRoutingMode: response.data.Table1.find(r => r.SubTitle === "AutoRoutingFlag")?.value || 0,
          periodicTimer: response.data.Table1.find(r => r.SubTitle === "AutoRoutingTimer")?.value || 0,
          iOtherManualActionsAlgoTypeID: String(response.data.Table[0].iOtherManualActionsAlgoTypeID),
          iManSingleRoutingAlgoTypeID: String(response.data.Table[0].iManSingleRoutingAlgoTypeID),
          iManBatchRoutingAlgoTypeID: String(response.data.Table[0].iManBatchRoutingAlgoTypeID),
          iPeriodicAlgoTypeID: String(response.data.Table[0].iPeriodicAlgoTypeID),
          iFinalRunAlgoTypeID: String(response.data.Table[0].iFinalRunAlgoTypeID),
          iPredictiveAlgoTypeID: String(response.data.Table[0].iPredictiveAlgoTypeID),

        }));
        } else {
          console.warn("No data found.");
        }
      
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
const handleSaveAffiliateLevelRouteSettings = async (AffID) => {
    try {
        xCancelSourceForGrid.current = APICom.GenerateSource();
        let params = {
            iAffiliateID:AffID,
            autoRoutingMode: parseInt(operationConstraintsData?.autoRoutingMode) || 0,
            periodicTimer: parseInt(operationConstraintsData?.periodicTimer) || 0,
            iPredictiveAlgoTypeID: parseInt(operationConstraintsData?.iPredictiveAlgoTypeID) > 0? parseInt(operationConstraintsData?.iPredictiveAlgoTypeID): 0,
            iFinalRunAlgoTypeID: parseInt(operationConstraintsData?.iFinalRunAlgoTypeID) > 0? parseInt(operationConstraintsData?.iFinalRunAlgoTypeID): 0,
            iPeriodicAlgoTypeID: parseInt(operationConstraintsData?.iPeriodicAlgoTypeID) > 0? parseInt(operationConstraintsData?.iPeriodicAlgoTypeID) : 0,
            iManBatchRoutingAlgoTypeID: parseInt(operationConstraintsData?.iManBatchRoutingAlgoTypeID) > 0? parseInt(operationConstraintsData?.iManBatchRoutingAlgoTypeID): 0,
            iManSingleRoutingAlgoTypeID: parseInt(operationConstraintsData?.iManSingleRoutingAlgoTypeID) > 0? parseInt(operationConstraintsData?.iManSingleRoutingAlgoTypeID): 0,
            iOtherManualActionsAlgoTypeID: parseInt(operationConstraintsData?.iOtherManualActionsAlgoTypeID) > 0? parseInt(operationConstraintsData?.iOtherManualActionsAlgoTypeID): 0
        };
        // Make the async request
        let response = await APICom.fetchData(
          "GenericManifestDotNetCoreURL",
          // "api/Settings/UpdateRouteBreakTime",
          `api/Routing/SetAffiliateLevelRouteSettings`,
          "post",
          {},
          params,
          xCancelSourceForGrid.current
        );
  
        if (response?.data) {
          setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Global Settings", body: "Global Settings saved Successfully", btnOkText: "OK" }));

         // alert(`Save successful`);
          GetAffiliateLevelRouteSettings(AffID);
        }
        else{
          setConfirmationModalObj1((prevState) => ({ ...prevState, show: true, title: "Global Settings", body: "Global Settings update failed", btnOkText: "OK" }));

         // alert('failure : did not save')
        }
        // Handle result if needed
      } catch (error) {
        console.error(`Error at saving, error`);
  
      }
};
  useEffect(() => {
    GetAffiliateLevelRouteSettings(AffID);
  }, [AffID]);

  return (
    <div className="container mt-4">
      <div className="row justify-content-center align-items-stretch">
                                                          <ConfirmationModal
              centered
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
              }}
              dialogClassName="modal-90w"
              aria-labelledby="contained-modal-title-vcenter"
              show={confirmationModalObj.show}
              Title={confirmationModalObj.title}
              Body={confirmationModalObj.body}
              onOk={handleConfirmationModalOk}
              onCancel={handleConfirmationModalCancel}
              onClose={handleConfirmationModalClose}
              btnCanceText={confirmationModalObj.btnCanceText}
              btnOkText={confirmationModalObj.btnOkText}
              ShowCancelButton={"true"}
            />
            <ConfirmationModal
              centered
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh'
              }}
              dialogClassName="modal-90w"
              aria-labelledby="contained-modal-title-vcenter"
              show={confirmationModalObj1.show}
              Title={confirmationModalObj1.title}
              Body={confirmationModalObj1.body}
              onOk={handleConfirmationModalClose}
              onCancel={handleConfirmationModalCancel}
              onClose={handleConfirmationModalClose}
              btnCanceText={confirmationModalObj1.btnCanceText}
              btnOkText={confirmationModalObj1.btnOkText}
              ShowCancelButton={"false"}
            />
        {/* Non-Admin Panel */}
        <div className="col-12 col-md-5 d-flex">
          <div className="card shadow-sm d-flex flex-column w-100">
            <div className="card-header fw-bold text-center">Non-Admin Panel</div>
            <div className="card-body flex-grow-1">
              
              <div className="mb-3 row">
                <div className="col-12 col-md-6">
                  <div className="border border-dark p-2 fw-bold">Auto Routing Mode</div>
                </div>
                <div className="col-12 col-md-6">
                  <select
                    name="autoRoutingMode"
                    className="w-100 border border-dark p-2"
                    value={operationConstraintsData.autoRoutingMode}
                    onChange={handleConstraintsChange}
                  >
                    <option value="">Select Mode</option>
                    <option value="0">No Auto Routing</option>
                    <option value="1">Final Run Only</option>
                    <option value="2">Final & Periodic Run</option>
                    <option value="3">Manual Control</option>
                  </select>
                </div>
              </div>

              <div className="mb-3 row">
                <div className="col-12 col-md-6">
                  <div className="border border-dark p-2 fw-bold">Periodic Timer</div>
                </div>
                <div className="col-12 col-md-6">
                  <input
                    type="number"
                    name="periodicTimer"
                    className="w-100 border border-dark p-2"
                    value={operationConstraintsData.periodicTimer}
                    onChange={handleConstraintsChange}
                    placeholder="No. of Minutes"
                  />
                </div>
              </div>
      {/* Save button bottom-right */}
      {/* <div className="mt-auto d-flex justify-content-end">
        <button type="button" className="btn btn-success px-4" 
                       onClick={() => {
        handleSaveAffiliateLevelRouteSettings(AffID);
        }}>
          <i className="bi bi-save"></i> Save
        </button>
      </div> */}
            </div>
          </div>
        </div>

        {/* Admin Panel */}
        <div className="col-12 col-md-5 d-flex">
          <div className="card shadow-sm d-flex flex-column w-100">
            <div className="card-header fw-bold text-center">Admin Panel</div>
            <div className="card-body flex-grow-1">

              <div className="mb-3 row">
                <div className="col-12 col-md-6">
                  <div className="border border-dark p-2 fw-bold">Predictive</div>
                </div>
                <div className="col-12 col-md-6">
                  <select
                    name="iPredictiveAlgoTypeID"
                    value={operationConstraintsData.iPredictiveAlgoTypeID}
                    onChange={handleConstraintsChange}
                    className="w-100 border border-dark p-2"
                  >
                    <option value="">Select Algorithm</option>
                    {algorithms.map((algorithm) => (
                      <option key={algorithm.id} value={algorithm.id}>
                        {algorithm.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-3 row">
                <div className="col-12 col-md-6">
                  <div className="border border-dark p-2 fw-bold">Final Run</div>
                </div>
                <div className="col-12 col-md-6">
                  <select
                    name="iFinalRunAlgoTypeID"
                    value={operationConstraintsData.iFinalRunAlgoTypeID}
                    onChange={handleConstraintsChange}
                    className="w-100 border border-dark p-2"
                  >
                    <option value="">Select Algorithm</option>
                    {algorithms.map((algorithm) => (
                      <option key={algorithm.id} value={algorithm.id}>
                        {algorithm.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-3 row">
                <div className="col-12 col-md-6">
                  <div className="border border-dark p-2 fw-bold">Periodic</div>
                </div>
                <div className="col-12 col-md-6">
                  <select
                    name="iPeriodicAlgoTypeID"
                    value={operationConstraintsData.iPeriodicAlgoTypeID}
                    onChange={handleConstraintsChange}
                    className="w-100 border border-dark p-2"
                  >
                    <option value="">Select Algorithm</option>
                    {algorithms.map((algorithm) => (
                      <option key={algorithm.id} value={algorithm.id}>
                        {algorithm.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-3 row">
                <div className="col-12 col-md-6">
                  <div className="border border-dark p-2 fw-bold">Batch</div>
                </div>
                <div className="col-12 col-md-6">
                  <select
                    name="iManBatchRoutingAlgoTypeID"
                    value={operationConstraintsData.iManBatchRoutingAlgoTypeID}
                    onChange={handleConstraintsChange}
                    className="w-100 border border-dark p-2"
                  >
                    <option value="">Select Algorithm</option>
                    {algorithms.map((algorithm) => (
                      <option key={algorithm.id} value={algorithm.id}>
                        {algorithm.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
      {/* Save button bottom-right */}
      {/* <div className="mt-auto d-flex justify-content-end">
        <button type="button" className="btn btn-success px-4"
                onClick={() => {
        handleSaveAffiliateLevelRouteSettings(AffID);
        }}>
                  <i className="bi bi-save"></i> Save
        </button>
      </div> */}
            </div>
                   
          </div>

        </div>
<div className="mt-2 d-flex justify-content-end" style={{ position: 'relative', bottom: '0px', right: '10px' }}>
  <button
    type="button"
    className="btn btn-success px-4"
    onClick={() => {
      handleSaveAffiliateLevelRouteSettings(AffID);
    }}
  >
    <i className="bi bi-save"></i> Save Settings
  </button>
</div>
      </div>
    </div>
  );
};

export default GlobalSettings;
